let pre = 'st';
let formItemEles = {};
let isInputEmp = (val) => {
  return !val && val !== 0 && val !== false;
}

// 对整个表单进行 验证
function valid(callback) {
  let existUnValid = false;
  let errMsg = ''
  let lastMsg = '';
	let lastEle = null;
	
	let formItems = this.formRef.$el.querySelectorAll('*[st-form-item-prop]');
	formItems.forEach((ele) => {
		// 拿到 输入框 文本框
		let inputEle = ele.querySelector('.st-form-item-input input') || ele.querySelector(".st-form-item-input textarea");
		if (inputEle) {
			let prop = ele.getAttribute('st-form-item-prop');
			
			// 是否规则内有 对应的必填
			let exsit_required = (this.rules[prop] !== undefined && (this.rules[prop].find((rl) => { return rl.type == 'required';}) !== undefined));
			if (!exsit_required && ele.getAttribute('required')) {
				let errMsg = this.st_required(prop, inputEle.value, inputEle.getAttribute('name') + '不能为空');
				if (errMsg) {
				  lastMsg = errMsg;
					lastEle = ele;
				  existUnValid = true;
				}
				this.toggleErr(prop, errMsg);
			}
			
			// 遍历设置的规则
			let rules = this.rules[prop] ? this.rules[prop] : [];
			for (let ri in rules) {
				let rule = rules[ri];
				prop = prop.replace(rule.type, '');
				let checkMethod = pre + '_' + rule.type;
				let inputVal = inputEle.value;
				
				// 执行相应的校验 方法
				if (typeof checkTool[checkMethod] === 'function') {
				  errMsg = checkTool[checkMethod](prop, inputVal, rule['error']);
				  if (errMsg) {
				    lastMsg = errMsg;
						lastEle = ele;
				    existUnValid = true;
				  }
				  checkTool.toggleErr(prop, errMsg);
				}
			}
			  
		}
	});
	

	if (lastEle) {
		lastEle.scrollIntoView({
			behavior: 'auto', // 平滑滚动
			block: 'center',    // 垂直居中对齐
			inline: 'nearest'   // 最近的水平对齐
		});
	}
	
  callback(!existUnValid, lastMsg);
}

// 设置规则
function setRule() {
	
}

let checkTool = {
  formRef: {},
  rules: {},
  valid: valid,
  st_required: (prop, val, error) => {
    const isValid = isInputEmp(val);

    let error_text = '';
    if (isValid) {
      error_text = error ? error: `${prop} 不允许为空`;
    }
    return error_text;
  },

	setListeners: setListeners,
  // 将错误信息 填到对应的formItem 下面
  toggleErr: function (prop, errMsg) {
    let errContentEle = this.formRef.$el.querySelector(`[st-form-item-prop='${prop}']`).querySelector('.st-err-msg');
    if (errMsg) {
      errContentEle.classList.remove('err-hide');
      errContentEle.textContent = errMsg;
    } else {
      errContentEle.textContent = '';
      errContentEle.classList.add('err-hide');
    }
  },
  // 弹出框 关闭 事件 监听
  inputPickerClose: function(prop = '') {
    // 通过属性 找到input
    if (prop) {
      let item = this.formRef.$el.querySelector(`[st-form-item-prop='${prop}']`);
      let inputEle = item.querySelector(".st-form-item-input input") || item.querySelector(".st-form-item-input textarea");
      if (inputEle) {
        setTimeout(() => {
          inputEle.focus();
          inputEle.blur();
        }, 0);
      }
    }

  },
}

// 处理规则  返回一个校验器
export let formValid = (formRef, formRule = {}) => {
  checkTool.formRef = formRef;
  // let formItems = formRef.$el.querySelectorAll('*[st-form-item-prop]');
  
  
  // 元素上 有 required 都要进行  必填判断
  // formItems.forEach((item) => {
  //   let inputEle = item.querySelector(".st-form-item-input input") || item.querySelector(".st-form-item-input textarea");
  //   if (inputEle) {
  //     let propName = inputEle.getAttribute('name');
  //     let prop = item.getAttribute('st-form-item-prop');
  //     propName = propName ? propName : prop;
  //     formItemEles[prop] = item;
    //   if (item.getAttribute('required')) {
    //     formRule[prop] = Array.isArray(formRule[prop]) ? formRule[prop] : [];
				// let requiredSet = formRule[prop].find((rl) => { return rl.type == 'required' });
				// if (requiredSet === undefined) {
				// 	formRule[prop].push({ type: 'required', trigger: ['blur', 'change'], error: `${propName} 不允许为空` });
				// }
        
    //   }
  //   }
  // });

  // 过掉重复的 类型
  // let formRullObject = {};
  // for (let prop in  formRule) {
  //   let propRules = formRule[prop];
  //   propRules.forEach((rule) => {
  //     formRullObject[prop + rule.type] = rule;
  //   });
  // }

  // 将规则挂载上去
  // checkTool.rules = formRule;
  checkTool.setListeners();

  return checkTool;
}

// 支持blur, change, fucos 事件
function setListeners() {
	let sup_triggers  = ['blur', 'change', 'focus'];
	// 获取所有的表单属性
	let formItems = this.formRef.$el.querySelectorAll('*[st-form-item-prop]');
	formItems.forEach((ele) => {
		// 拿到 输入框 文本框
		let inputEle = ele.querySelector('.st-form-item-input input') || ele.querySelector(".st-form-item-input textarea");
		if (inputEle) {
			let prop = ele.getAttribute('st-form-item-prop');
			
			// 注册事件
			sup_triggers.forEach((ev) => {
				inputEle.addEventListener(ev, (event) => {
					let exsit_required = (this.rules[prop] !== undefined && (this.rules[prop].find((rl) => { return rl.type == 'required';}) !== undefined));
					
					if (!exsit_required && ele.getAttribute('required') && (ev == 'blur' || ev == 'change')) {
						let errMsg = this.st_required(prop, event.target.value, event.target.getAttribute('name') + '不能为空');
						this.toggleErr(prop, errMsg);
					}
					if (this.rules[prop]) {
						this.rules[prop].forEach((rule) => {
							if (rule.trigger && rule.trigger.includes(ev)) {
								let checkMethod = pre + '_' + rule.type;
								// 执行相应的校验 方法
								if (typeof this[checkMethod] === 'function') {
								  let errMsg = this[checkMethod](prop, event.target.value, rule['error']);
								  this.toggleErr(prop, errMsg);
								}
							}
						});
						
					}
				});
			})
		}
	})
}

export default formValid;